import React from 'react';
import { getUrl } from '../../../utils';
import Link from './Link';

import styled from 'styled-components/macro';

const List = ({
  childs,
  eleccion,
  nomenclator,
  className = '',
  onSelection = () => {},
  selectedId,
  page,
  parentLevel,
}) => (
  <div className={className}>
    <Ul>
      {childs.map(child => (
        <li key={child.i}>
          <Link
            to={getUrl({
              id: child.i,
              eleccion,
              nomenclator,
              page,
              parentLevel,
            })}
            onClick={onSelection}
            selected={selectedId === child.i}
            css={`
              font-weight: ${({ selected }) => selected && 'bold'};
            `}
          >
            {child.n}
          </Link>
        </li>
      ))}
    </Ul>
  </div>
);

const StyledList = styled(List)`
  padding: 0px;
`;

const Ul = styled.ul`
  overflow: auto;
  max-height: 260px;
`;

export default StyledList;
